import React, { useContext, useState, useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
import { UserContext, OrgContext, SetupTrackerContext, ForecastContext } from '../../objects/Context';
import { WorkspaceContext } from '../../objects/Context';
import shortUUID from 'short-uuid';
import { ReactComponent as AgentIcon } from '../../assets/icons/star-icon.svg';
import { ReactComponent as AgentForecastIcon } from '../../assets/icons/usage-icon.svg';
import { ReactComponent as DashboardIcon } from '../../assets/icons/dashboard-icon.svg';
import { ReactComponent as ChatIcon } from '../../assets/icons/chat-icon.svg';
import { ReactComponent as AnomalyIcon } from '../../assets/icons/eye-icon.svg';
import { ReactComponent as DefinitionIcon } from '../../assets/icons/target-icon.svg';
import { ReactComponent as DataSourceIcon } from '../../assets/icons/data-icon.svg';
import { ReactComponent as SettingsIcon } from '../../assets/icons/settings-icon.svg';
import { ReactComponent as BuildIcon } from '../../assets/icons/build-icon.svg';
import { ReactComponent as AddIcon } from '../../assets/icons/plus-icon.svg';
import { ReactComponent as DownIcon } from '../../assets/icons/down-icon.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/edit-icon.svg';
import { ReactComponent as RightArrowIcon } from '../../assets/icons/arrow-right-icon.svg';
import { ReactComponent as SearchIcon } from '../../assets/icons/insight-icon.svg';
import { ReactComponent as MergeIcon } from '../../assets/icons/merge-icon.svg';
import { Link, useNavigate } from 'react-router-dom';
import './Menu.css';
import { ActiveMenuIndexContext } from '../../objects/Context';
import { MenuContext } from '../../objects/Context';
import { MenuWidthContext } from '../../objects/Context';
import { ReactComponent as CloseIcon } from '../../assets/icons/close-icon.svg';
import SetupTracker from '../GettingStarted/SetupTracker/SetupTracker';
import { CHAT_MODES } from '../../pages/Threads/helpers/modeConfigs';
import '../../pages/Dashboards/MoreSelectionMenu.css';
import { ReactComponent as NoteStackIcon } from '../../assets/icons/note-stack-icon.svg';
import Popup from '../Popup/Popup';
import LoadingScreen from '../LoadingScreen/LoadingScreen';

function Menu() {
  const { user } = useContext(UserContext);
  const { workspace } = useContext(WorkspaceContext);
  const { org } = useContext(OrgContext);
  const { activeMenuIndex } = useContext(ActiveMenuIndexContext);
  const { isMenuOpen, setIsMenuOpen, isMenuCondensed, setIsMenuCondensed } = useContext(MenuContext);
  const { setMenuWidth } = useContext(MenuWidthContext);
  const { forecasts, currentForecast, activeScenario, setActiveScenario, scenarios, setScenarios } = useContext(ForecastContext);
  const [loading, setLoading] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [contentItems, setContentItems] = useState([]);
  const [currentContentItem, setCurrentContentItem] = useState([]);
  const navigate = useNavigate();
  
  const [openSetupTrack, setOpenSetupTrack] = useState(false);
  const { setupSteps, setSetupSteps } = useContext(SetupTrackerContext);
  const [showModePicker, setShowModePicker] = useState(false);
  const menuRef = useRef(null);

  const cashFlowItems = [
    { label: 'Forecast', icon: AgentIcon, path: '/forecast' },
    { label: 'Reports', icon: NoteStackIcon, path: '/reports' },
    { label: 'Options', icon: BuildIcon, path: '/options' },
  ];

  const statementItems = [
    { label: 'Profit & Loss', iconText: 'PL', path: '/statements/profit-and-loss' },
    { label: 'Balance Sheet', iconText: 'BS', path: '/statements/balance-sheet' },
  ];

  const statementIconStyle = {
    backgroundColor: 'var(--blue-light-color)',
    borderRadius: '5px',
    color: 'white',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'var(--font-bold)',
    fontSize: '10px',
    lineHeight: '18px',
  };

  const workspaceItems = [
    { label: 'Data Sources', icon: DataSourceIcon, path: '/data-sources' },
    { label: 'Settings', icon: SettingsIcon, path: '/settings' },
  ];

  const [showCaseDropdown, setShowCaseDropdown] = useState(false);
  const [showNewScenarioPopup, setShowNewScenarioPopup] = useState(false);
  const [creatingScenario, setCreatingScenario] = useState(false);
  const scenarioInputRef = useRef(null);

  const actionItem = activeMenuIndex === 0 ? 'New Thread' : null;
  const contentTitle = activeMenuIndex === 0 ? 'My Threads' : null;

  // Get icon component from mode key
  const getIconComponent = (modeKey) => {
    switch (modeKey) {
      case 'general': return ChatIcon;
      case 'deep-research': return SearchIcon;
      case 'dashboard': return DashboardIcon;
      case 'anomaly': return AnomalyIcon;
      case 'cash-forecast': return MergeIcon;
      default: return ChatIcon;
    }
  };

  useEffect(() => {
    if (org?.id && org?.showSetup) {
      //getOrgSetup();
    }
  }, [org?.id, org?.showSetup]);

  useEffect(() => {
    if (activeMenuIndex === 0 && user.id) {
      setCurrentContentItem([]);
      getThreads();
    }
  }, [activeMenuIndex, user.id]);

  useEffect(() => {
    if (!mounted) {
      setMounted(true);
    }
  }, [mounted]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showModePicker && !event.target.closest('.new-thread-mode-picker')) {
        setShowModePicker(false);
      }
      if (showCaseDropdown && !event.target.closest('.case-dropdown-container')) {
        setShowCaseDropdown(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showModePicker, showCaseDropdown]);

  // Keep header path offset aligned with actual menu width
  useEffect(() => {
    const updateMenuWidth = () => {
      if (menuRef.current) {
        setMenuWidth(menuRef.current.offsetWidth || 0);
      }
    };
    updateMenuWidth();
    window.addEventListener('resize', updateMenuWidth);
    return () => window.removeEventListener('resize', updateMenuWidth);
  }, [isMenuCondensed, isMenuOpen, setMenuWidth]);

  const handleThreadClick = (thread) => {
    setIsMenuOpen(false);
    if (thread.id !== currentContentItem.id) {
      setCurrentContentItem(thread);
    }
  }

  // const getOrgSetup = async () => {
  //   try {
  //     const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/orgs/get-setup/${org.id}`, { withCredentials: true });
  //     if (response.data) {
  //       // Transform DynamoDB response to match the expected setupSteps format
  //       const transformedSteps = [
  //         { id: 1, title: 'Create Account', completed: response.data.createAccount || false },
  //         { id: 2, title: 'Connect Financial Data', completed: response.data.connectSource || false, path: '/data-sources' },
  //         { id: 3, title: 'Ask your First Question', completed: response.data.askFirstQuestion || false, path: '/forecast' },
  //         { id: 4, title: 'Create a Report', completed: response.data.buildDashboard || false, path: '/forecast?mode=dashboard' },
  //         { id: 5, title: 'Invite a Team Member', completed: response.data.inviteTeamMember || false, path: '/settings' }
  //       ];
  //       setSetupSteps(transformedSteps);
  //     }
  //   } catch (err) {
  //     console.error('Failed to fetch org setup', err);
  //   }
  // }

  const getThreads = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/get-threads/${user.id}/${workspace.id}`, { withCredentials: true });
      if (response.data) {
        const items = response.data
          .map((thread) => ({
            label: thread.title || 'Untitled Thread',
            path: `/forecast`,
            id: thread.id,
            thread: thread,
          }))
          .sort((a, b) => new Date(b.thread?.createdAt || 0) - new Date(a.thread?.createdAt || 0));
        setContentItems(items);
      }
    } catch (err) {
      console.error('Failed to fetch threads in menu', err);
    } finally {
      setLoading(false);
    }
  }

  const handleNewThreadClick = (e) => {
    e.stopPropagation();
    // Toggle inline mode picker near the button
    setShowModePicker((prev) => !prev);
  };

  const handleModeSelect = (modeKey) => {
    setShowModePicker(false);
    setIsMenuOpen(false);
    setCurrentContentItem([]);
    navigate('/forecast', { state: { presetMode: modeKey } });
  };

  const createNewThread = ({threadId, title}) => {
    const newThreadPath = `/forecast`;
    const thread = {
      id: threadId,
      title: title,
      userId: user.id,
      createdAt: new Date().toISOString(),
    };
    const item = {
      id: threadId,
      label: title,
      path: newThreadPath,
      thread: thread,
    }
    return item
  };

  const handleThreadNameUpdate = (event) => {
    const { threadId, newName, mode } = event.detail;
    const newThread = createNewThread({threadId: threadId, title: newName});
    if (mode) {
      newThread.thread.mode = mode;
    }
    setContentItems((prevItems) => {
      const itemExists = prevItems.some((item) => item.id === threadId);
      if (itemExists) {
        return prevItems.map((item) => {
          if (item.id === threadId) {
            return { ...item, label: newName, thread: { ...(item.thread || {}), mode: mode || item.thread?.mode } };
          }
          return item;
        });
      } else {
        return [
          ...prevItems,
          newThread,
        ];
      }
    });
    setCurrentContentItem(newThread);
  };

  const handleEdit = async (threadId) => {
    const newTitle = prompt('Enter new title for the thread:');
    if (newTitle) {
      try {
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/threads/edit-thread`, {
          userId: user.id,
          workspaceId: workspace.id,
          threadId,
          newTitle,
        }, { withCredentials: true });
        setContentItems((prevItems) =>
          prevItems.map((item) => (item.id === threadId ? { ...item, label: newTitle } : item))
        );
      } catch (err) {
        console.error('Failed to edit thread title', err);
      }
    }
  };

  const handleDelete = async (threadId) => {
    setContentItems((prevItems) => prevItems.filter((item) => item.id !== threadId));
      if (currentContentItem.id === threadId) {
        setCurrentContentItem([]);
      }
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/threads/delete-thread/${user.id}/${threadId}/${workspace.id}`, { withCredentials: true });
    } catch (err) {
      console.error('Failed to delete thread', err);
    }
  };

  const handleNavigation = (path, index) => {
    if (activeMenuIndex !== index) {
      setIsMenuOpen(false);
      navigate(path);
    }
  };

  const handleForecastSelect = (scenarioName) => {
    console.log(`Switching to scenario: ${scenarioName || 'BASE'}`);
    setShowCaseDropdown(false);
    setActiveScenario(scenarioName);
  };

  const handleCreateScenario = async (scenarioName) => {
    if (!scenarioName || scenarioName.trim() === '' || !currentForecast?.id) {
      return;
    }
    
    setCreatingScenario(true);
    try {
      const trimmedName = scenarioName.trim();
      console.log('Creating new scenario overlay:', trimmedName);
      
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/forecasts/scenarios/${currentForecast.id}/create`,
        { scenarioName: trimmedName },
        { withCredentials: true }
      );
      
      if (response.data.success) {
        console.log('Scenario created successfully:', response.data.scenario);
        setScenarios(prev => [...prev, response.data.scenario]);
        setActiveScenario(trimmedName);
        setShowNewScenarioPopup(false);
      }
    } catch (error) {
      console.error('Error creating scenario:', error);
      const errorMessage = error.response?.data?.error || 'Failed to create scenario. Please try again.';
      alert(errorMessage);
    } finally {
      setCreatingScenario(false);
    }
  };

  const groupedThreads = useMemo(() => {
    const sorted = [...contentItems].sort((a, b) => new Date(b.thread?.createdAt || 0) - new Date(a.thread?.createdAt || 0));
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startOfWeek = new Date(startOfToday);
    startOfWeek.setDate(startOfWeek.getDate() - startOfToday.getDay()); // Sunday as start of week

    const groups = { today: [], thisWeek: [], earlier: [] };
    for (const item of sorted) {
      const createdAtStr = item.thread?.createdAt;
      const createdAt = createdAtStr ? new Date(createdAtStr) : new Date(0);
      if (createdAt >= startOfToday) {
        groups.today.push(item);
      } else if (createdAt >= startOfWeek) {
        groups.thisWeek.push(item);
      } else {
        groups.earlier.push(item);
      }
    }
    return groups;
  }, [contentItems]);

  const renderNewScenarioPopup = () => (
    <Popup
      content={
        <div className="add-item-wrapper">
          <h2>New Scenario</h2>
          <div className="add-item-inputs">
            <input 
              type="text" 
              placeholder="Scenario Name (e.g., Upside, Downside)" 
              ref={scenarioInputRef}
              autoFocus
            />
          </div>

          <div className="add-item-actions">
            <button 
              className="add-item-button cancel" 
              onClick={() => setShowNewScenarioPopup(false)}
            >
              Cancel
            </button>
            <button 
              className="add-item-button create" 
              onClick={() => handleCreateScenario(scenarioInputRef.current?.value)}
            >
              Create Scenario
            </button>
          </div>
          {creatingScenario && <LoadingScreen />}
        </div>
      }
      onClose={() => setShowNewScenarioPopup(false)}
    />
  );

  return (
    <div ref={menuRef} className={`product-menu ${isMenuOpen ? 'open' : 'closed'} ${isMenuCondensed ? 'condensed' : ''}`}>
      <div className="close-button" onClick={() => setIsMenuOpen(false)}>
        <CloseIcon className="close-icon" />
      </div>
      
      {/* CASH FLOW Section */}
      <div className="menu-section">
        <div className="menu-section-header">{isMenuCondensed ? ' ' : 'CASH FLOW'}</div>
        
        {/* Forecast Case Dropdown */}
        {forecasts.length > 0 && (
          <div className="forecast-dropdown-wrapper">
            <div className="case-dropdown-container" onClick={() => setShowCaseDropdown(!showCaseDropdown)}>
              <div className="case-dropdown-trigger">
                <p className="case-label">
                  {activeScenario ? activeScenario.toUpperCase() : (currentForecast?.scenarioCase?.toUpperCase() || 'BASE')}
                </p>
                <DownIcon className="case-dropdown-icon" />
              </div>
            </div>
            {showCaseDropdown && (
              <div className="more-selection-menu forecast-list">
                <p className="section-label">Core Forecast</p>
                <div className="forecast-items">
                  <div 
                    className={`forecast-item ${!activeScenario ? 'active' : ''}`}
                    onClick={(e) => { 
                      e.stopPropagation(); 
                      handleForecastSelect(null); 
                    }}
                  >
                    <MergeIcon className='merge-icon' />
                    <span className='name'>BASE</span>
                    <RightArrowIcon className='icon' />
                  </div>
                </div>
                <p className="section-label">Scenarios</p>
                <div className="forecast-items">
                  {scenarios.length > 0 ? (
                    scenarios.map((scenario) => (
                      <div 
                        key={scenario.scenarioName}
                        className={`forecast-item ${activeScenario === scenario.scenarioName ? 'active' : ''}`}
                        onClick={(e) => { 
                          e.stopPropagation(); 
                          handleForecastSelect(scenario.scenarioName); 
                        }}
                      >
                        <MergeIcon className='merge-icon' />
                        <span className='name'>{scenario.scenarioName.toUpperCase()}</span>
                        <RightArrowIcon className='icon' />
                      </div>
                    ))
                  ) : (
                    <p className="empty-scenarios">No scenarios yet</p>
                  )}
                </div>
                <div className="actions">
                  <div className="action confirm" onClick={(e) => {
                    e.stopPropagation();
                    setShowCaseDropdown(false);
                    setShowNewScenarioPopup(true);
                  }}>
                    <AddIcon className='add-icon' />
                    <span>New Scenario</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        
        <ul>
          {cashFlowItems.map((item, index) => (
            <li key={index} className={`menu-item ${item.label.toLowerCase().replace(/\s+/g, '-')} ${activeMenuIndex === index ? 'active' : ''}`}>
              <div className="menu-item-link" onClick={() => handleNavigation(item.path, index)}>
                <item.icon className="menu-icon"/>
                <p className={`menu-label ${activeMenuIndex === index ? 'active' : ''}`}>{item.label}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* STATEMENTS Section */}
      <div className="menu-section">
        <div className="menu-section-header">{isMenuCondensed ? ' ' : 'STATEMENTS'}</div>
        <ul>
          {statementItems.map((item, index) => {
            const actualIndex = cashFlowItems.length + index;
            return (
              <li key={index} className={`menu-item ${item.label.toLowerCase().replace(/\s+/g, '-')} ${activeMenuIndex === actualIndex ? 'active' : ''}`}>
                <div className="menu-item-link" onClick={() => handleNavigation(item.path, actualIndex)}>
                  <span className="menu-icon" style={statementIconStyle}>{item.iconText}</span>
                  <p className={`menu-label ${activeMenuIndex === actualIndex ? 'active' : ''}`}>{item.label}</p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>

      {/* WORKSPACE Section */}
      <div className="menu-section">
        <div className="menu-section-header">{isMenuCondensed ? ' ' : 'WORKSPACE'}</div>
        <ul>
          {workspaceItems.map((item, index) => {
            const actualIndex = cashFlowItems.length + statementItems.length + index;
            return (
              <li key={index} className={`menu-item ${item.label.toLowerCase().replace(/\s+/g, '-')} ${activeMenuIndex === actualIndex ? 'active' : ''}`}>
                <div className="menu-item-link" onClick={() => handleNavigation(item.path, actualIndex)}>
                  <item.icon className="menu-icon"/>
                  <p className={`menu-label ${activeMenuIndex === actualIndex ? 'active' : ''}`}>{item.label}</p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
      {/* {activeMenuIndex === 0 && !isMenuCondensed && (
        <>
          <hr />
          <div className="sub-menu-container">
            {actionItem && (
              <div className="sub-menu-button new-thread-mode-picker" onClick={handleNewThreadClick} style={{ position: 'relative' }}>
                <AddIcon className="add-icon" />
                <p className="add-label">{actionItem}</p>
                {showModePicker && (
                  <div className="more-selection-menu" style={{ left: '0', top: 'calc(100% + 8px)', right: 'auto', bottom: 'auto', zIndex: 1000, minWidth: '300px' }}>
                    {Object.values(CHAT_MODES).map((mode) => {
                      const IconComponent = getIconComponent(mode.key);
                      return (
                        <div
                          key={mode.key}
                          className={`more-option`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleModeSelect(mode.key);
                          }}
                        >
                          <div className={`mode-icon-wrapper`} style={{ backgroundColor: mode.themeColor }}>
                            {IconComponent && <IconComponent className="mode-icon" />}
                          </div>
                          <div className="mode-texts">
                            <div className="mode-label" style={{ fontFamily: 'var(--font-bold)', color: 'var(--grey-medium-color)', fontSize: '14px' }}>{mode.label}</div>
                            {mode.desc && <div className="mode-desc" style={{ fontSize: '12px', color: 'var(--grey-medium-color)', marginTop: '2px', lineHeight: '1.2' }}>{mode.desc}</div>}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
            <div className="sub-menu-content">
              <div className="content-title">
                <p className="title-label">{contentTitle}</p>
                <DownIcon className="title-icon" />
              </div>
              <ul>
                {['today', 'thisWeek', 'earlier'].map((sectionKey) => {
                  const sectionTitle = sectionKey === 'today' ? 'Today' : sectionKey === 'thisWeek' ? 'This week' : 'Earlier';
                  const items = groupedThreads[sectionKey] || [];
                  if (!items.length) return null;
                  return (
                    <React.Fragment key={`section-${sectionKey}`}>
                      <li className="section-subtitle" key={`subtitle-${sectionKey}`}>
                        <p className="subtitle-label">{sectionTitle}</p>
                      </li>
                      {items.map((item) => {
                        const threadModeKey = item?.thread?.mode || 'general';
                        const modeConfig = CHAT_MODES[threadModeKey] || CHAT_MODES.general;
                        const IconComponent = getIconComponent(modeConfig.key);
                        return (
                          <li key={item.id} className="item">
                            <div
                              className={`menu-item-container${currentContentItem.id === item.id ? ' active' : ''}`}
                              onClick={() => handleThreadClick(item)}
                            >
                              <div className="menu-line"></div>
                              <div
                                className="mode-icon-wrapper"
                                style={{ backgroundColor: modeConfig.themeColor }}
                              >
                                {IconComponent && <IconComponent className="mode-icon" />}
                              </div>
                              <p className={`menu-label${currentContentItem.id === item.id ? ' active' : ''}`}>{item.label}</p>
                            </div>
                            <div className="thread-icons">
                              <EditIcon className="edit-icon" onClick={() => handleEdit(item.id)} />
                              <DeleteIcon className="delete-icon" onClick={() => handleDelete(item.id)} />
                            </div>
                          </li>
                        );
                      })}
                    </React.Fragment>
                  );
                })}
              </ul>
            </div>
          </div>
        </>
      )}
      {org?.showSetup && (
        <div className="setup-button" onClick={() => setOpenSetupTrack(!openSetupTrack)}>
          <div className="setup-label">Finish Setup</div>
          <DownIcon className={`setup-icon ${openSetupTrack ? 'open' : 'closed'}`} />
        </div>
      )} */}
      <div className={`menu-condensed-container ${isMenuCondensed ? 'closed' : 'open'}`} onClick={() => setIsMenuCondensed(!isMenuCondensed)}>
          <RightArrowIcon className="condensed-icon" />
      </div>
      {org?.showSetup && openSetupTrack && <div className="setup-tracker-container" > <SetupTracker closePage={() => setOpenSetupTrack(false)} /></div>}
      {showNewScenarioPopup && renderNewScenarioPopup()}
    </div>
  );
}

export default Menu;